// extracted by mini-css-extract-plugin
export var buttonAccept = "styles-module--buttonAccept--d1099";
export var buttonSettings = "styles-module--buttonSettings--18253";
export var cookiebanner = "styles-module--cookiebanner--34513";
export var heading = "styles-module--heading--462c3";